// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__dP8ai","container":"About_container__pxvGf","aboutContainer":"About_aboutContainer__pXEFJ","aboutImg":"About_aboutImg__Vzagm"};